<template>
  <div class="textfield">
    <select
      v-bind="$attrs"
      ref="select"
      v-model="innerValue"
      class="textfield__input"
      @input="$emit('input', $event.target.value)"
      @change="blur"
    >
      <option
        disabled
        selected
        value
      />

      <option
        v-for="(option, key) in options"
        :key="key"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <label
      class="textfield__label"
      :for="name"
      :class="{'textfield__label--filled': !empty}"
    >
      {{ fieldLabel }}
    </label>
    <svg
      class="textfield__icon"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
    >
      <path d="M7 10l5 5 5-5H7z" />
    </svg>
  </div>
</template>

<script>
// eslint-disable-next-line @teamwork/cfb-rules/component-paths
export default {
  props: {
    value: {
      type: null,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    /** @type {{ label: string; value: string }} */
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      innerValue: '',
    };
  },
  computed: {
    empty() {
      return this.innerValue.length === 0;
    },
    isRequired() {
      return true;
    },
    fieldLabel() {
      const label = this.label || this.name;
      return this.isRequired ? `${label} *` : label;
    },
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    blur() {
      this.$refs.select.blur();
      this.$emit('item-selected');
    },
  },
};
</script>

<style lang="scss" scoped>
.textfield {
  position: relative;
  margin-bottom: 18px;

  &__input {
    position: relative;
    display: inline-flex;
    background: #FFFFFF;
    border: 1px solid #C5CADA;
    box-sizing: border-box;
    border-radius: 4px;
    appearance: none;
    font-size: 16px;
    padding: 11px 12px;
    width: 100%;
    color: #000000;
    letter-spacing: 0.1px;
    padding-right: 45px;

    &:hover {
      border-color: #9e9e9e;
    }
  }

  &__label {
    position: absolute;
    left: 12px;
    top: 18px;
    pointer-events: none;
    font-size: 14px;
    line-height: 100%;
    color: #727491;
    white-space: nowrap;
    transform-origin: top left;
    transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  &__icon {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
    fill: #727491;
    transition: transform 250ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
  }

  // focus + filled state
  &__input:focus {
    outline: none;
    border-color: #4461D7;
    caret-color: #4461D7;
    border-width: 2px;
    padding: 10px 11px;
  }

  &__input:focus + &__label, &__label--filled {
    top: -6px;
    padding: 0 2px;
    transform: scale(0.85);
    color: #4461D7;
    background: white;
  }

  &__input:focus ~ &__icon {
    fill: #4461D7;
    transform: rotate(180deg);
  }

  &__label--filled {
    color: #727491;
  }
}
</style>



// WEBPACK FOOTER //
// TwSelect.vue?7708ed10